$(document).ready(function () {

    $('.add-scroll').click(function(){
        $('html, body').animate({
            scrollTop: $('#contacts').offset().top
        }, 400);
    })
});